<label
  class="switch"
  [class.switch--checked]="checked()"
  [class.switch--disabled]="isDisabled()"
>
  <input
    class="switch__input"
    type="checkbox"
    role="switch"
    [id]="id()"
    [attr.aria-describedby]="hint() ? id() + '-hint' : null"
    [attr.aria-checked]="checked()"
    [checked]="checked()"
    [disabled]="isDisabled()"
    (change)="onNativeChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />

  <span
    class="switch__control"
    aria-hidden="true"
  >
    <span class="switch__thumb"></span>
  </span>

  @if (label() || hint()) {
  <span class="switch__text">
    @if (label()) {
    <span class="switch__label">{{ label() | translate }}</span>
    } @if (hint()) {
    <span
      class="switch__hint"
      [id]="id() + '-hint'"
      >{{ hint() | translate }}</span
    >
    }
  </span>
  }
</label>
